module.exports = __webpack_public_path__ + "static/img/play.6b97175.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/play.png
// module id = cUGd
// module chunks = 1